import 'dom-slider';

const Active = {
  init: (pgurl) => {
    Active.menuLinks = document.querySelectorAll('.menu__item');
    Active.sublevel = document.querySelectorAll('.menu__sublevel');
    Active.menuAgence = document.querySelectorAll('.menu__item--agence');
    Active.menuLinks.forEach(link => {
      if (pgurl === '/agence' || pgurl === '/agency') {
        Active.menuAgence.forEach(agence => { agence.innerHTML = agence.textContent; })
      } else {
        Active.menuAgence.forEach(agence => { agence.innerHTML = '<a href="' + agence.dataset.href + '">' + agence.textContent + '</a>'; })
      }

      link.classList.remove('menu__item--inactive');
      link.classList.remove('menu__item--active');
      if (pgurl != '/' && pgurl != '/home' && link.dataset.menu.indexOf(pgurl) > -1) {
        link.classList.add('menu__item--active');
      } else {
        link.classList.add('menu__item--inactive');
      }
      if (pgurl == '/' || pgurl == '/home') {
        Active.sublevel.forEach(sub => { sub.slideUp(600, 'cubic-bezier(0.645, 0.045, 0.355, 1)'); })
      } else {
        Active.sublevel.forEach(sub => {
          if (sub.dataset.sublevel.indexOf(pgurl) > -1){
            sub.slideDown(600, 'cubic-bezier(0.645, 0.045, 0.355, 1)');
          } else {
            sub.slideUp(600, 'cubic-bezier(0.645, 0.045, 0.355, 1)'); 
          } 
        })
      }
    })
  }
};

export default Active;
